package com.milta.feature.profile.domain.usecase

import com.milta.feature.profile.domain.repository.ProfileRepository

class GetMyDriverLinkCodeUseCase(private val repository: ProfileRepository) {
    suspend operator fun invoke(): Result<String> = repository.getLinkCode()
}
